import { render, staticRenderFns } from "./MemberManageDialog.vue?vue&type=template&id=61367a98&scoped=true"
import script from "./MemberManageDialog.vue?vue&type=script&lang=js"
export * from "./MemberManageDialog.vue?vue&type=script&lang=js"
import style0 from "./MemberManageDialog.vue?vue&type=style&index=0&id=61367a98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61367a98",
  null
  
)

export default component.exports